import React from 'react';
import styled from 'styled-components';

import { CSSBackgroundImageFilters } from './styles';
import { JRCLoader } from 'components/JRCLoader/JRCLoader';
import { JRCIcon } from 'components/JRCIcon/JRCIcon';

import { useImageLoader } from 'hooks/UseImageLoader';

const CSSLoading = styled.div<{ height?: number; minHeight: number; minWidth?: number }>`
    ${(props) => (props.minWidth ? `min-width: ${props.minWidth}px` : 'min-width: 100%')};
    ${(props) => (props.height ? `height: ${props.height}px` : 'auto')};
    min-height: ${(props) => props.minHeight}px;
    flex: 1;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    background-color: ${(props) => props.theme.color.grey0};
`;

const CSSImgWrapper = styled.div<{ width: number; height?: number; minWidth?: number; minHeight: number }>`
    background-color: ${(props) => props.theme.color.grey0}px;
`;

/**
 * use of !important because of tinymce
 */
const CSSImg = styled.img`
    width: 100%;
    height: 100% !important;
    object-fit: contain;
    object-position: center;
    transition: all 0.4s;
    :hover {
        scale: 1.04;
        transition: all 0.4s;
    }
`;

export type JRCWidgetImageProps = {
    useFilter?: boolean;
    maxWidth: number;
    maxHeight?: number;
    uri?: string;
    loadWithDelay?: number;
};

export const JRCWidgetImage = ({
    useFilter = false,
    maxWidth = 800,
    maxHeight,
    uri,
    loadWithDelay,
}: JRCWidgetImageProps) => {
    const { width, loading, error } = useImageLoader(
        uri ?? '/img/applications/articleWidgets/widget-article-image-placeholder.png',
        maxWidth,
        loadWithDelay,
    );

    return (
        <CSSImgWrapper
            minWidth={maxWidth}
            width={width < maxWidth ? maxWidth : width}
            height={maxHeight}
            minHeight={maxWidth / (16 / 9)}>
            <CSSBackgroundImageFilters useFilter={useFilter ? useFilter : false}>
                <CSSImg src={uri} loading="lazy" />
            </CSSBackgroundImageFilters>
            {loading && (
                <CSSLoading minWidth={maxWidth} height={maxHeight} minHeight={maxWidth / (16 / 9)}>
                    <JRCLoader />
                </CSSLoading>
            )}
            {error && !loading && (
                <CSSLoading minWidth={maxWidth} height={maxHeight} minHeight={maxWidth / (16 / 9)}>
                    <JRCIcon name="icon-warning" />
                </CSSLoading>
            )}
        </CSSImgWrapper>
    );
};
